import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {PackingInfoStatusType} from "../../../../deliveries/types/packing-info-status.type";
import * as _ from "lodash";

require('./service-packed-indication.scss');
@Component({
  standalone: false,
  selector: 'app-service-packed-indication',
  templateUrl: './service-packed-indication.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicePackedIndicationComponent implements OnInit, OnChanges {
  @Input() isPacked: any;
  @Input() packingInfo: any;
  @Input() packedDate: any;
  @Input() packageList: any;
  @Input() serviceType: any;

  public hasMissingPackages: boolean;
  public packingDisplayStatus: PackingInfoStatusType;
  public packingInfoStatusTypes: typeof PackingInfoStatusType = PackingInfoStatusType;
  public iconFill: string;
  public statusFillColor: object;
  public packagesCount: number = 0;

  constructor() {
  }

  ngOnInit() {
    this.statusFillColor = {
      InProcess: '#317AD5',
      NotPacked: '#7E7E7E',
      Packed: '#3FA300'
    }
    this._setHasMissingPackages();
    this._setDisplayStatus();
    this.setPackagesCount();

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.packageList && !changes.packageList.isFirstChange() ||
      changes.isPacked && !changes.isPacked.isFirstChange() ||
      changes.packingInfo && !changes.packingInfo.isFirstChange()) {
      this._setHasMissingPackages();
      this._setDisplayStatus();
      this.setPackagesCount();
    }
  }

  private setPackagesCount() {
    this.packagesCount = _.reduce(this.packageList, (totalItems, p: any) => {
      return totalItems + p.count;
    }, 0) || 0;
  }

  private _setHasMissingPackages() {
    const packageListRef = this.packageList ? this.packageList[0] : {items: []};
    this.hasMissingPackages = packageListRef.items.find(item => {
      return item.missing;
    })
    if (this.hasMissingPackages) {
      this.iconFill = '#F56565';
    }
  }

  private _setDisplayStatus() {
    this.packingDisplayStatus = this.packingInfo?.status ||
      (this.isPacked ? this.packingInfoStatusTypes.Packed : this.packingInfoStatusTypes.NotPacked);
    if (!this.hasMissingPackages) {
      this.iconFill = this.statusFillColor[this.packingDisplayStatus];
    }
  }

}
